{
  "enum": {
    "O5MessagingV1WireEncoding": {
      "J5_JSON": "J5 JSON",
      "PROTOJSON": "Protojson",
      "RAW": "Raw",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "oneOf": {
    "O5MessagingV1Problem": {
      "unhandledError": "Unhandled Error"
    }
  }
}